export default __webpack_public_path__ + "static/media/bottle_lemon.a65d85af.png";